// This is generated.  Alter it in blockGroups/workflowPanes/types/WorkflowCriteriaPane.js
/* eslint-disable no-unused-vars */
const { Type } = require('@sinclair/typebox');
const { actionUtils } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
const { merge } = require('lodash');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context,
    parentAccessRestrictions,
  ) {
    const { children, propertyName = 'criteria' } = hNode;

    // Use hNode.securityModifier to figure out access restrictions
    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    // If the context role or feature flags does not result in access to this (or sub) component
    // don't include any part of it in the data dictionary.
    if (accessRestrictions.hidden) return [{}, {}];

    // Process children to get their partial type definitions
    // Each child (e.g., MultiPickerDropDownCriteria) returns a partialTypeDefinition
    // with properties like { 'location:company': criteriaSchema }
    let [_subDataDictionary = {}, _partialTypeDefinition = {}] =
      children?.reduce(
        ([sdd, ptd], child) => {
          const [_subDataDictionary = {}, _partialTypeDefinition = {}] =
            context.extractFromChild(child, context, accessRestrictions);
          return [
            merge(sdd, _subDataDictionary),
            moduleRegistration.mergePartialTypeDefinitions(
              ptd,
              _partialTypeDefinition,
              context,
            ),
          ];
        },
        [{}, {}],
      ) ?? [{}, {}];

    // Build the criteria item schema from the merged child type definitions
    // Each criteria item is an object that can contain any of the child criteria properties
    const criteriaItemSchema = Type.Object(_partialTypeDefinition, {
      title: 'Criteria Item',
      'x-dataType': 'object',
      additionalProperties: false,
    });

    // Wrap in a criteria array
    const criteriaArraySchema = Type.Optional(
      Type.Array(criteriaItemSchema, {
        title: 'Criteria',
        'x-dataType': 'array',
        'x-propertyName': propertyName,
      }),
    );

    // Return the criteria property as a partial type definition
    // This will be merged into the parent form's schema
    const partialTypeDefinition = {
      [propertyName]: criteriaArraySchema,
    };

    return [_subDataDictionary, partialTypeDefinition];
  },
};
moduleRegistration.registerHNodeType(
  'workflowPanes',
  'WorkflowCriteriaPane',
  module.exports,
);
